import Vue from 'vue';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

Vue.use(Toast, {
  position: POSITION.TOP_RIGHT,
  transition: 'Vue-Toastification__fade',
  transitionDuration: 600,
  timeout: 5000,
  maxToasts: 20,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.5,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  bodyClassName: ['toast-notification-body'],
});
